<template>
  <div style="padding: 20px;background-color: #ffffff;">
    <div class="">
      <div @keyup.enter.stop="getPage({pageNum: 1})">
        <el-select v-model="queryParam.batchId" @change="getSpecialtyList" placeholder="选择考试" filterable style="width:200px;margin-right:10px;">
          <el-option v-for="(item,index) in batchList" :key="index" :label="item.batchName" :value="item.batchId" :class="item.disabled?'none':''"></el-option>
        </el-select>
        <el-select v-model="queryParam.specialtyId" placeholder="所属专业" @change="getPage({pageNum: 1})" filterable style="width:200px;margin-right:10px;margin-bottom: 10px;">
          <el-option v-for="(item,index) in specialtyList" :key="index" :label="item.specialtyName" :value="item.specialtyId" :class="item.disabled?'none':''"></el-option>
        </el-select>
        <el-select v-model="queryParam.agentId" placeholder="考级点" filterable style="width:200px;margin-right:10px;margin-bottom: 10px;">
          <el-option v-for="(item,index) in agentList" :key="index" :label="item.agentName" :value="item.agentId" :class="item.disabled?'none':''"></el-option>
        </el-select>
        <el-input style="width:200px;margin-right:10px;margin-bottom: 10px;" @clear="getPage({pageNum: 1})" v-model="queryParam.examineeName" clearable placeholder="考生姓名"></el-input>
        <el-input style="width:200px;margin-right:10px;margin-bottom: 10px;" @clear="getPage({pageNum: 1})" v-model="queryParam.examineeIdNo" clearable placeholder="证件号"></el-input>
        <el-input style="width:200px;margin-right:10px;margin-bottom: 10px;" @clear="getPage({pageNum: 1})" v-model="queryParam.admissionTicketNo" clearable placeholder="准考证号"></el-input>
        <el-select v-model="queryParam.isImport" placeholder="缴费方式" filterable clearable style="width: 200px;margin-right:10px;">
          <el-option v-for="(item,index) in Tool.map2arr($enums.isImport)" :key="index" :label="item.value" :value="item.key" :class="item.disabled?'none':''"></el-option>
        </el-select>
        <el-select v-model="queryParam.isRepeat" placeholder="重复报名" filterable clearable style="width: 200px;margin-right:10px;">
          <el-option v-for="(item,index) in Tool.map2arr($enums.isRepeat)" :key="index" :label="item.value" :value="item.key" :class="item.disabled?'none':''"></el-option>
        </el-select>
        <el-select v-model="queryParam.status" placeholder="状态" filterable clearable style="width: 200px;margin-right:10px;">
          <el-option v-for="(item,index) in Tool.map2arr($enums.examStatus)" :key="index" :label="item.value" :value="item.key" :class="item.disabled?'none':''"></el-option>
        </el-select>
        <el-button @click="getPage({pageNum: 1})" type="primary">搜索</el-button>
        <el-button @click="queryParam=JSON.parse(JSON.stringify(oldQueryParam)),getPage({pageNum: 1}),getSpecialtyList()" type="default">重置</el-button>
        <el-button @click="$router.push({path:'./redo',query:queryParam})" type="default">返回</el-button>
      </div>
      <div class="text-right" style="margin-top: 10px;">
        <el-button @click="reSetNext()" type="primary" style="margin-right: 0px;">
          顺延下期
        </el-button>
      </div>
    </div>
    <div ref="page" style="margin-top: 12px;">
      <el-table :data="page.list" stripe :height="tableHeight" size="medium" @selection-change="multipleSelection=$event">
        <el-table-column type="selection" width="55"></el-table-column>
        <el-table-column prop="orderId" label="报考订单号"></el-table-column>
        <el-table-column prop="admissionTicketNo" label="准考证号"></el-table-column>
        <el-table-column prop="examineeName" label="姓名">
          <template slot-scope="scope">
            <span v-show="!scope.row.trueEye2">
              <span>{{scope.row.examineeName}}</span>
              <i style="margin-left: 5px;" class="el-icon-view" @click="reloadName(scope.$index, scope.row)"></i>
            </span>
            <span v-show="scope.row.trueEye2">
              <span>{{scope.row.examineeName2}}</span>
              <i style="margin-left: 5px;" class="el-icon-view" @click="reloadName(scope.$index, scope.row)"></i>
            </span>
          </template>
        </el-table-column>
        <el-table-column prop="agentName" label="考级点"></el-table-column>
        <el-table-column prop="categoryName" label="所属分类"></el-table-column>
        <el-table-column prop="specialtyName" label="所属专业">
          <template slot-scope="scope">
            {{scope.row.specialtyName}}-{{scope.row.gradeName}}
          </template>
        </el-table-column>
        <el-table-column prop="examineeIdNo" label="证件号">
          <template slot-scope="scope">
              <span v-show="!scope.row.trueEye">
                <span>{{scope.row.examineeIdNo}}</span>
                <i style="margin-left: 5px;" class="el-icon-view" @click="reloadIdNo(scope.$index, scope.row)"></i>
              </span>
            <span v-show="scope.row.trueEye">
                <span>{{scope.row.examineeIdNo2}}</span>
                <i style="margin-left: 5px;" class="el-icon-view" @click="reloadIdNo(scope.$index, scope.row)"></i>
              </span>
          </template>
        </el-table-column>
        <el-table-column prop="isImport" label="缴费方式">
          <template slot-scope="scope">
            {{$enums.isImport[scope.row.isImport]}}
          </template>
        </el-table-column>
        <el-table-column prop="isRepeat" label="重复报名">
          <template slot-scope="scope">
            {{$enums.isRepeat[scope.row.isRepeat]}}
          </template>
        </el-table-column>
        <el-table-column prop="status" label="状态">
          <template slot-scope="scope">
            {{$enums.examStatus[scope.row.status]}}
          </template>
        </el-table-column>
        <el-table-column label="操作" width="200">
          <template slot-scope="scope">
            <el-button size="mini" type="text" style="color: #E91212;" @click="reSet(scope.row)">重新录制</el-button>
            <el-button size="mini" type="text" style="color: #E91212;" @click="modifyExam(scope.row)">修改考试</el-button>
          </template>
        </el-table-column>
      </el-table>
      <div style="margin-top: 20px;">
        <el-pagination class="text-center" background
                       :page-sizes="[20, 50, 100, 200]" layout="total, sizes, prev, pager, next, jumper"
                       :total="page.total" :page-size="page.pageSize" :current-page="page.pageNum"
                       @current-change="getPage({pageNum:$event})" @size-change="getPage({pageNum:1,pageSize:$event})"></el-pagination>
      </div>
    </div>
    <el-dialog title="修改考试" v-if="editForm.show" :visible.sync="editForm.show" width="500px"
               :close-on-press-escape="false" :close-on-click-modal="false" :destroy-on-close="true">
      <Edit :row="editForm.row" @close="getPage()"></Edit>
    </el-dialog>
  </div>
</template>
<script>
import Edit from './redo-select-edit'

export default {
  name: 'list',
  components: { Edit },
  props: [],
  data () {
    return {
      tableHeight: 200,
      queryParam: { batchId: this.$route.query.batchId },
      oldQueryParam: {},
      page: { pageSize: 20, pageNum: 1 },
      multipleSelection: [],
      batchList: [],
      specialtyList: [],
      agentList: [],
      editForm: { show: false, row: null, title: '修改考试' }
    }
  },
  async created () {
    this.batchList = await this.$HTTP.ApiBatch.getList({ batchStatus: [2, 3] })
    if (this.Tool.isNull(this.batchList)) {
      throw new Error('没有考试数据')
    }
    if (!this.queryParam.batchId) {
      this.queryParam.batchId = this.batchList[0].batchId
    }
    await this.getSpecialtyList()
    this.oldQueryParam = JSON.parse(JSON.stringify(this.queryParam))
  },
  async mounted () {
    this.Tool.windowResizeEvent(() => {
      this.tableHeight = this.Tool.calcTableHeight(this.$refs['page'])
    })
  },
  async beforeDestroy () {
  },
  computed: {},
  watch: {},
  methods: {
    async getSpecialtyList (event) {
      this.specialtyList = await this.$HTTP.ApiSpecialty.getList({ batchId: this.queryParam.batchId })
      this.agentList = await this.$HTTP.ApiBatch.getAgentList(this.queryParam.batchId)
      if (event) {
        this.queryParam.specialtyId = ''
        this.queryParam.agentId = ''
      }
      await this.getPage()
    },
    async getPage (queryParam) {
      try {
        this.editForm.show = false
        this.editForm.row = null
        this.queryParam = Object.assign({}, this.queryParam, queryParam)
        let page = await this.$HTTP.ApiExamOnline.getPage(this.queryParam)
        if (page.list) {
          page.list.map(el => {
            this.$set(el, 'examineeIdNo2', el.examineeIdNo)
            this.$set(el, 'examineeName2', el.examineeName)
            this.$set(el, 'trueEye2', true)
            this.$set(el, 'trueEye', true)
            el.examineeIdNo2 = el.examineeIdNo.replace(/^(.{6})(?:\w+)/, "\$1********")
            el.examineeName2 = el.examineeName.replace(/(?<=.)./g, '*')
          })
        }
        this.page = page
        this.$nextTick(() => {
          let wrapper = window.document.getElementsByClassName('el-table__body-wrapper')
          if (wrapper) {
            wrapper[0].scrollTop = 0
          }
        })
      } catch (e) {
        this.Tool.doError(e)
      }
    },
    async reloadIdNo (index, row) {
      if (row.trueEye == true) {
        this.$set(row, 'trueEye', false)
      } else {
        this.$set(row, 'trueEye', true)
      }
    },
    async reloadName (index, row) {
      if (row.trueEye2 == true) {
        this.$set(row, 'trueEye2', false)
      } else {
        this.$set(row, 'trueEye2', true)
      }
    },
    async reSet (row) {
      try {
        let confirm = await this.$confirm('确定要让该考生重新录制吗？', '提示', { type: 'warning' })
        if (confirm === 'confirm') {
          const data = {
            examId: row.examId,
            resetType: 0
          }
          console.log(data)
          await this.$HTTP.ApiExamOnline.reSet(data)
          this.$message({ type: 'success', message: '操作成功' })
          await this.getPage()
        }
      } catch (e) {
        this.Tool.doError(e)
      }
    },
    async reSetNext () {
      if (!this.multipleSelection.length) {
        throw new Error('请选择要操作的记录')
      }
      try {
        let confirm = await this.$confirm('确定要让该考生顺延下期吗？', '提示', { type: 'warning' })
        if (confirm === 'confirm') {
          // await this.$HTTP.ApiExamOnline.reSet(data)
          await this.$HTTP.ApiExamOnline.reSet({
            examIds: this.Tool.joinList(this.multipleSelection, 'examId'),
            resetType: 1
          })
          this.$message({ type: 'success', message: '操作成功' })
          await this.getPage()
        }
      } catch (e) {
        this.Tool.doError(e)
      }
    },
    async modifyExam (row) {
      this.editForm.show = true
      if (row) {
        this.editForm.row = row
      } else {
        this.editForm.row = ''
      }
    }
  }
}
</script>
